export const pad = (input) => {
  const str = String(input)
  if (str.length < 2) {
    return "0" + str
  }
  return str
}

export const format = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
